import { CLEAR_REQUEST_STATUS } from 'state/requests/RequestStatusReducer';

export const UPDATE_ONBOARDING_MAINTENANCE_OPT_OUT = 'UPDATE_ONBOARDING_MAINTENANCE_OPT_OUT';
export const updateOnboardingMaintenanceOptOut = (missionName, optOut) => ({
  type: UPDATE_ONBOARDING_MAINTENANCE_OPT_OUT,
  missionName,
  optOut
});

export const RESET_ONBOARDING_MAINTENANCE_OPT_OUT = 'RESET_ONBOARDING_MAINTENANCE_OPT_OUT';
export const resetOnboardingMaintenanceOptOut = () => ({
  type: RESET_ONBOARDING_MAINTENANCE_OPT_OUT
});

export const clearOnboardingMaintenanceOptOut = () => ({
  type: CLEAR_REQUEST_STATUS,
  payload: {
    requestStatus: 'updateMission'
  }
});
